const textFieldFormServiceQuesList = {
  comment: 'Comentario',
  
};

export default textFieldFormServiceQuesList;
